<template>
    <div class="header" @click="commonBuriedPointFun()">
      <div style="display: flex;justify-content: flex-start; line-height: 40px;align-items: center;">
        <img src="https://oss.81lianpin.com/picture/34/dd/93/1f80498059e08d51c94531b3ffd7f28d.png" class="volume-o">
        <ul class="list">
          <li v-for="(item, index) in ulList" :key="index" :class="!index && play ? 'toUp' : ''">
            {{ item.msg }}
          </li>
        </ul>
      </div>
      
      <p class="jobbtn"  style="">
        <span style="padding-left:6px ;">找工作</span>
        <van-icon name="arrow" />
      </p>
    </div>
</template>

<script>
import {commonBuriedPoint } from '@/api/getData'
import {NoticeBar } from 'vant';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Fingerprint2 from 'fingerprintjs2'
export default {
  name: 'Header',
  components: {
    NoticeBar
  },
  data() {
    return {
      ulList: [
        { msg: '同年退役，为啥ta不愁找工作？秘密是…' },
        { msg: '你不是找不到好工作，而是没找对入口' },
        { msg: '好岗位急招人，快来投递，招满即停' },
      ],
      play: false,
      visitorId:'', //唯一标识
    }
  },
  async mounted() {
    let vm = this
    // const fp = await FingerprintJS.load()
    // const result = await fp.get()
    // this.visitorId = result.visitorId
    // console.log('唯一标识', this.visitorId)
    Fingerprint2.get(function(components) {
      const values = components.map(function(component,index) {
        if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
          return component.value.replace(/\bNetType\/\w+\b/, '')
        }
        return component.value
      })
      // 生成最终id murmur   
      vm.visitorId = Fingerprint2.x64hash128(values.join(''), 31);
      console.log('唯一标识', vm.visitorId)
    });
    setInterval(this.startPlay, 4000)
  },
  destroyed() {
    clearInterval(this.startPlay) // 页面销毁时清除定时器
  },

  methods: {
    // 埋点
    commonBuriedPointFun(){
      let data = {
        eventType:24,
        bizId: this.visitorId 
      }
      commonBuriedPoint(data).then(res=>{
        window.location  = 'https://sjh5.81lianpin.com/merge/job'
      })
    },
 
    startPlay() {
      let that = this
      that.play = true //开始播放
      setTimeout(() => {
        that.ulList.push(that.ulList[0]) //将第一条数据塞到最后一个
        that.ulList.shift() //删除第一条数据
        that.play = false //暂停播放,此处修改，保证每一次都会有动画显示
      }, 500)
    },

  }
}
</script>

<style scoped>
.header {
  /* position: fixed;
  top: 0px;
  left: 0px; */
  width: 100%;
  height: 80px;
  padding: 0 30px;
  line-height: 80px;
  font-size: 28px;
  font-weight: 900;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  /* z-index: 10; */
  color: #A45E00;
  overflow: hidden;
  background: #FBDBAF;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}



.header .toUp {
  margin-top: -80px;
  transition: all 0.5s;
}

.header  .list {
  list-style: none;
  text-align: center;
  overflow: hidden;
  height: 80px;
  line-height: 80px;
  padding: 0;
  margin: 0;

}
.header  li {
  align-items: center;
  text-align: left;
  height: 80px;
  line-height: 84px;
}
.header  .jobbtn{
  width: 112px;
  height: 50px;
  background: #B8741A;
  border-radius: 8px;
  font-size: 24px;
  font-weight: 400;
  color: #FBFBFB;
  line-height: 50px;
  display: flex;justify-content: center; align-items: center;
}
.volume-o{
  padding-right: 20px;
  width:27px;height: 22px;
}
</style> 


// WEBPACK FOOTER //
// src/components/Header.vue